import { render, staticRenderFns } from "./SupervisorButtons.vue?vue&type=template&id=0cfa819e"
import script from "./SupervisorButtons.vue?vue&type=script&lang=js"
export * from "./SupervisorButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports